<script lang="ts">
	import SummaryStats from './SummaryStats.svelte';
	import InDepthStats from './InDepthStats.svelte';
	import Knockdowns from './Knockdowns.svelte';
	import type { BoutStats } from '../types';

	export let stats: BoutStats | undefined;
	export let statsType: 'live' | 'final';
</script>

<fragment>
	{#if stats}
		<div class="d-flex mb-3 justify-content-end">
			<div class="empty-sidebar d-none d-sm-block" />
			<ul class="nav nav-pills">
				<li class="nav-item">
					<a
						class="nav-link active"
						aria-current="page"
						data-bs-toggle="pill"
						data-bs-target="#{statsType}-total">Total</a
					>
				</li>
				{#each stats.rounds as round}
					<li class="nav-item">
						<a
							class="nav-link"
							aria-current="page"
							data-bs-toggle="pill"
							data-bs-target="#{statsType}-round-{round.roundNumber}">{round.roundNumber}</a
						>
					</li>
				{/each}
			</ul>
		</div>
		<div class="tab-content">
			{#each stats.rounds as round}
				<div class="tab-pane show" id="{statsType}-round-{round.roundNumber}" role="tabpanel">
					<SummaryStats blue={round.blueCorner.summary} red={round.redCorner.summary} />

					<InDepthStats blue={round.blueCorner.inDepth} red={round.redCorner.inDepth} />
					<Knockdowns blue={round.blueCorner.knockdowns} red={round.redCorner.knockdowns} />
				</div>
			{/each}
			<div class="tab-pane show active" id="#{statsType}-totals" role="tabpanel">
				<SummaryStats blue={stats.totals.blueCorner.summary} red={stats.totals.redCorner.summary} />

				<InDepthStats blue={stats.totals.blueCorner.inDepth} red={stats.totals.redCorner.inDepth} />
				<Knockdowns
					blue={stats.totals.blueCorner.knockdowns}
					red={stats.totals.redCorner.knockdowns}
				/>
			</div>
		</div>
	{:else}
		<div class="d-flex">
			<div class="empty-sidebar d-none d-sm-block" />
			<div class="text-center w-100">
				<p>Loading...</p>
			</div>
		</div>
	{/if}
</fragment>

<style>
	.nav-pills .nav-link {
		color: rgb(73, 73, 73);
		cursor: pointer;
	}

	.nav-pills .nav-link.active {
		background-color: #adb5bd;
		color: white;
	}
</style>
